import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";
import "bootstrap-icons/font/bootstrap-icons.css";
import { sessionStore } from "@/stores/Session";
import { watch, useTemplateRef } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mainNavRef = useTemplateRef("mainNav");
watch(
  () => sessionStore().session,
  (newSession) => {
    if (newSession) {
      mainNavRef.value.updateMenubar();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainNav, { ref: "mainNav" }, null, 512),
    _createVNode(_component_router_view, { class: "container-xxl my-3" }),
    _createVNode(Footer)
  ]))
}
}

})